import { ApiClientFactory } from "common/middleware/api.client-factory";
import { Logger } from "common/middleware/logger";
import {
  ProjectEmailContentDto,
  LanguageType,
  NoteType,
  GetProjectEmailCopyQuery,
} from "common/middleware/api.services";

export const generateProjectEmailCopy = async (
  key: string,
  projectId: number,
  noteType: NoteType,
  requestedCulture: LanguageType,
  clientsName: string,
): Promise<ProjectEmailContentDto> => {
  if (
    !projectId
    || !noteType
    || !requestedCulture
    || !clientsName
  ) {
    return;
  }

  Logger.debug("Getting email copy");

  const client = await ApiClientFactory.getProjectsClient();

  return await client.generateProjectEmailCopy(
    projectId,
    GetProjectEmailCopyQuery.fromJS({
      projectId,
      noteType,
      requestedCulture,
      clientsName,
    })
  );
}
